import Svg, { Defs, Ellipse, LinearGradient, Path, Stop } from 'react-native-svg'

export const QrStand = ({ height = 168, width = 108, color = '#fff' }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path fill="url(#a)" d="M1 18h121v150H1z" />
      <Ellipse cx={61.5} cy={18.566} fill={color} rx={60.5} ry={18.185} />
      <Path stroke="url(#b)" d="M122 25.566c0 10.044-27.087 18.185-60.5 18.185S1 35.61 1 25.566" />
      <Defs>
        <LinearGradient id="a" x1={10} x2={107.5} y1={18} y2={168} gradientUnits="userSpaceOnUse">
          <Stop stopColor={color} stopOpacity={0.4} />
          <Stop offset={1} stopColor={color} stopOpacity={0} />
        </LinearGradient>
        <LinearGradient id="b" x1={1} x2={107.5} y1={44} y2={44} gradientUnits="userSpaceOnUse">
          <Stop stopColor={color} stopOpacity={0.1} />
          <Stop offset={0.491} stopColor={color} stopOpacity={0.509} />
          <Stop offset={1} stopColor={color} stopOpacity={0.1} />
        </LinearGradient>
      </Defs>
    </Svg>
  )
}
